import { Component, computed, inject, signal } from '@angular/core';
import { AnalysisTimepointRow } from '@api-response-types/analysis-version-group.response';
import { PmLinkComponent } from '@libs/ui';
import { DateUtilsService } from '@core/utils/date-utils.service';
import { Store } from '@ngrx/store';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-enterprise';
import { ConfigurationsSelectors } from 'demand-forecasting/store/configurations/configurations.selectors';
import { selectAllForecastVersions } from 'demand-forecasting/store/forecast-version/forecast-version.selectors';
import { ConfigurationRouterHelperService } from 'demand-forecasting/store/router-state/configuration-router-helper.service';

@Component({
  selector: 'pm-open-forecast-version-cell',
  templateUrl: './open-forecast-version-cell.component.html',
  imports: [PmLinkComponent],
  host: {
    class: 'block h-full',
  },
})
export class OpenForecastVersionCellComponent implements ICellRendererAngularComp {
  private readonly configurationRouteHelperService = inject(
    ConfigurationRouterHelperService,
  );
  private readonly store = inject(Store);
  private readonly configuration = this.store.selectSignal(
    ConfigurationsSelectors.selectConfigurationByUrlParam,
  );
  private readonly versions = this.store.selectSignal(
    selectAllForecastVersions,
  );

  private readonly dateUtilsService = inject(DateUtilsService);

  protected versionId = signal<string | null>(null);

  protected dateLabel = computed(() => {
    const versionId = this.versionId();
    if (!versionId) {
      return '';
    }
    const version = this.versions().find((v) => v.id === versionId);
    if (!version) {
      return '';
    }
    return this.dateUtilsService.formatDateBasedOnLanguage(version.createdAt);
  });

  agInit(params: ICellRendererParams<AnalysisTimepointRow>): void {
    this.versionId.set(params.data?.versionId ?? null);
  }
  refresh(params: ICellRendererParams<AnalysisTimepointRow>): boolean {
    this.versionId.set(params.data?.versionId ?? null);
    return true;
  }

  onOpen(versionId: string) {
    const configuration = this.configuration();

    if (!configuration) {
      console.error(
        'No configuration in open-forecast-version-cell.component!',
      );
      return;
    }

    const initialQueryParams =
      this.configurationRouteHelperService.getInitialQueryParams(configuration);

    this.configurationRouteHelperService.setInitialConfigurationRoute(
      {
        ...initialQueryParams,
        configurationId: configuration.id,
        versionId,
      },
      false,
      true,
    );
  }
}
